import { useState } from 'react'

const EMPTY_ROW = { title: '', pub_date: '', link: '', authors: '' }

/**
 * Editable child rows (course lessons, podcast talks, video parts) for the
 * request forms and admin modals. The rows are sent inline on the parent's
 * payload, and the backend deletes any stored row absent from the list, so
 * removing a row here is all a delete needs.
 */
const useSubResourceRows = (emptyRow = EMPTY_ROW) => {
    const [rows, setRows] = useState([])

    const handleFormChange = (index, event) => {
        const { name, value } = event.target
        setRows(rows.map((row, i) => (i === index ? { ...row, [name]: value } : row)))
    }

    const addFields = () => setRows([...rows, { ...emptyRow }])

    const removeFields = (index) => setRows(rows.filter((_, i) => i !== index))

    return { rows, setRows, handleFormChange, addFields, removeFields }
}

export default useSubResourceRows
